import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import { Button, Modal } from 'react-bootstrap';
import { assetsLiabilitiesSelectOptions, industrySelectOptions, limitSelectOptions } from '../formData';
import '../AdvancedSearch.less';
import { BusinessOnlyField, IndustryField, AssetsField, LiabilitiesField } from '../fields';

const FinancialFilterModal = ({ onSave, show, onClose, filter }) => (
  <Modal
    show={show}
    onHide={onClose}
    // backdrop="static"
    // keyboard={false}
    dialogClassName="advanced-search-modal"
  >
    <div>
      <Form
        onSubmit={onSave}
        initialValues={filter}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>Financial Filters</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="advanced-search-form">
                <div className="form-item form-item-row">
                  <div className="col-2">
                    <BusinessOnlyField
                      limitSelectOptions={limitSelectOptions}
                      disabled={['petitions', 'schedules'].includes(filter.tab)}
                    />
                  </div>
                  <div className="col-2">
                    <IndustryField industrySelectOptions={industrySelectOptions} />
                  </div>
                </div>
                <div className="form-item form-item-row">
                  <div className="col-2">
                    <AssetsField assetsLiabilitiesSelectOptions={assetsLiabilitiesSelectOptions} />
                  </div>
                  <div className="col-2">
                    <LiabilitiesField assetsLiabilitiesSelectOptions={assetsLiabilitiesSelectOptions} />
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={onClose}>Cancel</Button>
              <Button bsStyle="primary" type="submit">
                Apply
              </Button>
            </Modal.Footer>
          </form>
        )}
      />
    </div>
  </Modal>
);

FinancialFilterModal.propTypes = {
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
  filter: PropTypes.object.isRequired,
};

FinancialFilterModal.defaultProps = {
  show: false,
};

export default FinancialFilterModal;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/resultForms/FinancialFilterModal.jsx